type CandidateApplicationRouteArgs = {
  candidateId: string | null | undefined;
  applicationId: string | null | undefined;
  jobId?: string | null | undefined;
  fromJob?: boolean;
  tab?: string | null | undefined;
};

function appendParam(params: URLSearchParams, key: string, value: string | null | undefined) {
  const cleanValue = String(value ?? '').trim();
  if (cleanValue) params.set(key, cleanValue);
}

export function buildForkHireCandidateApplicationPath({
  candidateId,
  applicationId,
  jobId,
  fromJob = false,
  tab,
}: CandidateApplicationRouteArgs) {
  const cleanCandidateId = String(candidateId ?? '').trim();
  if (!cleanCandidateId) return '/candidates';

  const params = new URLSearchParams();
  appendParam(params, 'app', applicationId);
  appendParam(params, 'tab', tab);

  if (fromJob) {
    params.set('from', 'job');
    appendParam(params, 'job', jobId);
  }

  const query = params.toString();
  return `/candidates/${encodeURIComponent(cleanCandidateId)}${query ? `?${query}` : ''}`;
}
